import { render, staticRenderFns } from "./AudienceList.vue?vue&type=template&id=230cad6e&scoped=true&"
import script from "./AudienceList.vue?vue&type=script&lang=js&"
export * from "./AudienceList.vue?vue&type=script&lang=js&"
import style0 from "./AudienceList.vue?vue&type=style&index=0&id=230cad6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230cad6e",
  null
  
)

export default component.exports